<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <epsHeader :drawer="$store.state.drawer"></epsHeader>
    <br /><br /><br /><br />

    <v-row></v-row>

    <v-col cols="12" sm="6" md="6">
      <v-row class="ml-6" dense>
        <v-card
          v-for="item in cardItems"
          :key="item.name"
          :elevation="2"
          :class="{
            'selected-card': selectedCard === item.name,
            'default-card': selectedCard !== item.name
          }"
          class="back-hover align-center justify-center mr-10 d-flex flex-column"
          @click="selectCard(item.name)"
        >
          <v-img
            v-if="item.icon"
            :src="item.icon"
            contain
            :width="selectedCard === item.name ? '70' : '30'"
            :height="selectedCard === item.name ? '70' : '30'"            
          />
          <b :class="{'selected-text': selectedCard === item.name, 'default-text': selectedCard !== item.name}">
            <div class="linkname px-3 pb-4">{{ item.label }}</div>
          </b>
        </v-card>
      </v-row>
    </v-col>
    <v-col cols="12" class="mt-2">
      <component :is="selectedComponent"></component>
    </v-col>
  </div>
</template>

<script>
import epsHeader from "../shared/UpdatedHeader";

const componentsMap = {
  "default-values": () => import("@/components/RoleManagement/DefaultValues"),
  "default-type-value": () => import("@/components/RoleManagement/DefalultTypeValue"),
  "configuration-master": () => import("@/components/Admission/AdmissionMaster/ConfigurationMaster"),
};

export default {
  components: {
    epsHeader,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    selectedCard: null,
    selectedComponent: null,
    cardItems: [
      {
        name: "default-values",
        label: "Default Values",
        icon: "https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/Role Management/Default_values.png",
      },
      {
        name: "default-type-value",
        label: "Default Value Type",
        icon: "https://eduplusschool.s3.ap-south-1.amazonaws.com/Role_link_icons/Role%20Management/Defualt_value_type.png",
      },
      {
        name: "configuration-master",
        label: "Configuration Master",
        icon: "https://wws-schoolerp.s3.ap-south-1.amazonaws.com/Role_link_icons/wws/1/configurationwlu4ay79re.png",
      },
    ],
  }),
  methods: {
    async selectCard(cardName) {
      this.selectedCard = cardName;
      try {
        if (componentsMap[cardName]) {
          const component = await componentsMap[cardName]();
          this.selectedComponent = component.default;
        }
      } catch (error) {
        console.error("Component loading failed", error);
      }
    },
  },
};
</script>

<style scoped>
.back-hover {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 16px !important;
}

.back-hover:hover {
  transform: translateY(-8px);
  box-shadow: 20px 20px 20px grey !important;
}
.selected-card {
  height: 140px;
  width: 240px;
  background-color: #8f6cf7;
  border: 2px solid white;
  color: white;
  font-size: 17px !important;
}

.default-card {
  height: 90px;
  width: 150px;
  background-color: #c4b0ff;
  color: black;
}

.selected-card .card-text {
  color: white !important;
}

.default-card .card-text {
  color: black !important;
}
.selected-text {
  font-size: 18px; /* Larger font for selected card */
  color: white !important;
}

.default-text {
  font-size: 12px; /* Default font size */
  color: black !important;
}

.v-avatar.elevated-avatar {
  border: 2px solid #5c6bc0;
  background: linear-gradient(to right, #9575cd, #7986cb);
  color: white;
}
</style>
